export const createElementAddClass = (tagName: string, className: string) => {
	const element = document.createElement(tagName);
	element.classList.add(className);
	return element;
}
